export const text = {
  MANUALLY_VERIFY: 'Manually verify',
  MANUALLY_VERIFY_TEXT:
    'Please note that manually verifying this status will override the original status and cannot be undone. If a mistake is made, you will need to resend a verification request to the patient.',
  CANCEL: 'Cancel',
  SEND_VERIFICATION_REQUEST: 'Send verification request',
  SEND_VERIFICATION_REQUEST_MESSAGE:
    'Please note that sending a new verification request will discard the previously saved Vouched job, along with any manual verification that has occurred. This action cannot be undone.',
  SEND_REQUEST: 'Send request',
}
